export class CreateSupportTicketRequest {
  /**
   * Creates a new support ticket request.
   *
   * @param {object} ticket Ticket creation payload
   * @param {string} ticket.description Detailed description of the issue (required)
   * @param {string} ticket.subject Short subject line of the ticket
   * @param {string} ticket.name Name of the requester (the person creating the ticket)
   * @param {string} ticket.email Email address of the requester
   * @param {number} ticket.status Ticket status (e.g., 2 = Open, 3 = Pending, 4 = Resolved, 5 = Closed)
   * @param {number} ticket.priority Ticket priority (e.g., 1 = Low, 2 = Medium, 3 = High, 4 = Urgent)
   * @param {number} ticket.source Ticket source (e.g., 1 = Email, 2 = Portal, 3 = Phone, etc.)
   * @param {string} [ticket.type] Ticket type (e.g., "Question", "Incident", "Problem", "Feature Request")
   * @param {string} [ticket.parcelNumber] Custom field for parcel/order number (if defined in Freshdesk custom fields)
   */
  constructor({
    description,
    subject,
    name,
    email,
    status,
    priority,
    source,
    type,
    parcelNumber,
  }) {
    return {
      description,
      subject,
      name,
      email,
      status,
      priority,
      source,
      type,
      custom_fields: {
        cf_parcel_number: parcelNumber,
      },
    };
  }
}

export class GetSupportTicketsRequest {
  /**
   * Creates a get support tickets request.
   *
   * @param {object} req Ticket creation payload
   * @param {string} req.email the legal address of the ticketanization
   */
  constructor({ email }) {
    return {
      email,
    };
  }
}
